import { render } from 'preact';
import { App } from './App';

// Import the Babylon app to initialize it (for WebXR)
import './main.app';

if (import.meta.env.DEV ) {
  // import("./utils/stats").then(({ initStats }) => initStats()).catch(() => {});
  // import("./utils/eruda").then(({ initEruda }) => initEruda()).catch(() => {});
}
const appElement = document.getElementById('app');
if (appElement) {
  render(<App />, appElement);
}

